import { TranslationRecord } from '../../../TranslationRecord';
import { plTranslations } from '../../../global-translations/pl';

export const plMessages: TranslationRecord = {
  ...plTranslations,
  FORM_TITLE: 'Zamów Assistance wysyłając zdjęcie z miejsca zdarzenia',
  UPLOAD_IMAGE: 'Dołącz poniżej zdjęcie z miejsca zdarzenia',
  SELECT_FILE_FROM_DISK: 'wybierz plik z dysku',
  DESKTOP_UPLOAD_IMAGE_TITLE: 'Przenieś i dodaj plik tutaj lub',
  DESKTOP_UPLOAD_IMAGE_ADDITIONAL_TEXT: 'Dostępne formaty: jpg, png, bmp o rozmiarze do 4 MB',
  PHONE_NUMBER: 'Wpisz numer telefonu',
  PHONE_NUMBER_HELPER_TEXT: 'Ułatwi nam to szybki kontakt z Tobą',
  NEXT: 'Przejdź dalej',
  INFO_CARD_TITLE: '**Postępuj zgodnie z poniższymi wytycznymi:**',
  INFO_CARD_CONTENT_1:
    '1. Dodaj zdjęcie z wypadku z widocznym **numerem tablicy rejestracyjnej**.\nNa tej podstawie odczytamy **lokalizację miejsca zdarzenia**.',
  INFO_CARD_CONTENT_2:
    '2. Gotowe! Teraz nasz ruch. Czekaj na informację o pomocy z naszej strony.\nWkrótce zadzwonimy do Ciebie.',
  CONSENT_TO_CONTACT_AND_READ_INFO:
    'Administratorem Państwa danych osobowych jest Towarzystwo Ubezpieczeń Wzajemnych TUW z siedzibą w Warszawie, ul. Raabego 13, 02-793 Warszawa. Szczegółowe informacje o przetwarzaniu Państwa danych osobowych znajdują się',
  INFORMATION_REGARDING_DATA_PROCESSING: 'tutaj.',
  CAN_NOT_READ_PLATE_NUMBER_FROM_IMAGE: 'Uwaga! Tablice rejestracyjne nie zostały poprawnie odczytane ze zdjęcia',
  CAN_NOT_READ_LOCALIZATION: 'Uwaga! Twoja lokalizacja miejsca zdarzenia nie została poprawnie wczytana ze zdjęcia.',
  HAS_BEEN_RECEIVED_FOR_PROCESSING: 'przyjęliśmy do realizacji',
  WE_WILL_CONTACT_WITH_YOU_WITHIN_A_FEW_MINUTES:
    'Już wkrótce skontaktujemy się z Tobą w sprawie udzielenia pomocy Assistance. Po rozmowie z naszym konsultantem otrzymasz wiadomość SMS z linkiem do śledzenia trasy pomocy drogowej. Jesteśmy w kontakcie!',
};
